import { formFieldsPlaygroundFields as fields } from "./formFieldsPlayground.schema";
import { accessScopeOptions } from "./formFieldsPlaygroundChoice.schema";
import { StateRow, TIP } from "./FormFieldsPlaygroundStateRow";

/** The checkbox, switch and radio kit fields in every state. */
export const FormFieldsPlaygroundChoiceRows = () => (
    <>
        <StateRow
            title="fields.Checkbox"
            cells={{
                normal: (
                    <fields.Checkbox
                        name="checkbox.normal"
                        label="I understand"
                    />
                ),
                optional: (
                    <fields.Checkbox
                        name="checkbox.optional"
                        label="Email me a copy"
                        optional
                    />
                ),
                tip: (
                    <fields.Checkbox
                        name="checkbox.tip"
                        label="Print memo"
                        description={TIP}
                    />
                ),
                error: (
                    <fields.Checkbox
                        name="checkbox.error"
                        label="Accept the terms"
                    />
                ),
                disabled: (
                    <fields.Checkbox
                        name="checkbox.disabled"
                        label="I understand"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Switch"
            cells={{
                normal: (
                    <fields.Switch name="switch.normal" label="Default from" />
                ),
                optional: (
                    <fields.Switch
                        name="switch.optional"
                        label="Send receipts"
                        optional
                    />
                ),
                tip: (
                    <fields.Switch
                        name="switch.tip"
                        label="Print memo"
                        description={TIP}
                    />
                ),
                error: <fields.Switch name="switch.error" label="TLS" />,
                disabled: (
                    <fields.Switch
                        name="switch.disabled"
                        label="Default from"
                        disabled
                    />
                ),
            }}
        />
        <StateRow
            title="fields.Radio"
            cells={{
                normal: (
                    <fields.Radio
                        name="radio.normal"
                        label="Permissions"
                        options={accessScopeOptions}
                    />
                ),
                optional: (
                    <fields.Radio
                        name="radio.optional"
                        label="Guest access"
                        optional
                        options={accessScopeOptions}
                    />
                ),
                tip: (
                    <fields.Radio
                        name="radio.tip"
                        label="Permissions"
                        description={TIP}
                        options={accessScopeOptions}
                    />
                ),
                error: (
                    <fields.Radio
                        name="radio.error"
                        label="Permissions"
                        options={accessScopeOptions}
                    />
                ),
                disabled: (
                    <fields.Radio
                        name="radio.disabled"
                        label="Permissions"
                        disabled
                        options={accessScopeOptions}
                    />
                ),
            }}
        />
    </>
);
